import {
    setCalendarColorScheme,
    getColorSchemeForCalendarColor,
    getAssignedCalendarColor,
} from 'owa-calendar-color-resolver';
import CalendarColor from 'owa-service/lib/contract/CalendarColor';

export function setTeamsChannelCalendarColorScheme(teamsChannelCalendarFolderId: string) {
    let assignedCalendarColors = getAssignedCalendarColor(teamsChannelCalendarFolderId);
    if (!assignedCalendarColors) {
        assignedCalendarColors = getColorSchemeForCalendarColor(CalendarColor.Auto, false);
    }

    setCalendarColorScheme(teamsChannelCalendarFolderId, assignedCalendarColors);
}
